import { Contact } from "@/type/core/dashboard/dashboard.types";
import { ContactCategoriesResponseDto } from "@state/contact/response/contact.categories.response.dto";
import configuration from "@utils/Config";
import {
  restCreationHandler,
  restDeletionHandler,
  restDetailsHandler,
  restPostHandlerReceivingMultipart,
  restUpdateHandler,
  restUpdateMultipartHandler,
} from "@utils/rest/RestClient";
import { createEffect } from "effector";
import { OfficeContactsResponseDto } from "@state/offices/dto/response/office.contacts.response.dto";
import { ExportContactRequestDto } from "@state/contact/request/export.contact.request.dto";

const baseUrl = configuration.backendBaseUrl;
const contactUrl = baseUrl + "/ws/fo/contact";
const officeUrl = "/office";
const categoriesUrl = "/categories";
const importUrl = contactUrl + "/import";
const exportUrl = contactUrl + "/export";

export const requestSearchContactCategoriesForOffice = createEffect({
  handler: restDetailsHandler<ContactCategoriesResponseDto>(
    contactUrl + officeUrl,
    categoriesUrl,
  ),
});

export const requestSearchContactsForOffice = createEffect({
  handler: restDetailsHandler<OfficeContactsResponseDto>(
    contactUrl + officeUrl,
  ),
});

export const requestDeleteContact = createEffect({
  handler: restDeletionHandler<void>(contactUrl),
});

export const requestImportContacts = createEffect({
  handler: restUpdateMultipartHandler<OfficeContactsResponseDto>(importUrl),
});

export const requestUpdateContact = createEffect({
  handler: restUpdateHandler<Contact, void>(contactUrl),
});

export const requestCreateContact = createEffect({
  handler: restCreationHandler<Contact, Contact>(contactUrl),
});

export const requestExportContact = createEffect({
  handler: restPostHandlerReceivingMultipart<ExportContactRequestDto, Blob>(
    exportUrl,
  ),
});
